export const RELEASE_FEATURES = {
  socialEvents: process.env.NEXT_PUBLIC_ENABLE_SOCIAL_EVENTS === "true",
} as const;
